import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Entity,
  LabelEntity,
  TextField,
  Checkbox,
  TextFieldEmpty,
  stylesSelect,
  InputContainer,
  Area,
  LabelOption,
  Error,
  FromGroup,
} from "./style";
import { Controller, useFormContext } from "react-hook-form";
import Select from "@components/form/Select";
import { IOptions } from "@components/form/Select/interface";
import {
  getEapb,
  getEntitiesByType,
  getEntitiesType,
  getEps,
  getIps,
} from "@api/services/parameterization";
import { AppContext } from "@context";
import { TypesLoading } from "@context/types/loading";
import { useLocation } from "react-router-dom";
const Legal = () => {
  const { register, watch, errors, setValue, control } = useFormContext();
  const typeEntity = watch("entityType");
  const location = useLocation();
  console.log(typeEntity, "entityType");
  const [entityType, setEntityType] = useState<IOptions[]>([]);
  const [entities, setEntities] = useState<IOptions[]>([]);
  const [eps, setEps] = useState<IOptions[]>([]);
  const [ips, setIps] = useState<IOptions[]>([]);
  const [eapb, setEapb] = useState<IOptions[]>([]);
  const { state, dispatch } = useContext(AppContext);
  //Condition
  /*  const isEps = entity === "eps";
  const isIps = entity === "ips";
  const isEt = entity === "et";
  const isSs = entity === "ss";
  const isOs = entity === "os";*/
  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: TypesLoading.Loading });
        const responseEps = await getEps(1);
        const epsState = responseEps.info.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
        setEps(epsState);
        const responseIps = await getIps(1);
        const ipsState = responseIps.info.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setIps(ipsState);
        const responseEapb = await getEapb();
        const eapbState = responseEapb.info.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setEapb(eapbState);
        dispatch({ type: TypesLoading.NotLoading });
      } catch (err) {
        dispatch({ type: TypesLoading.NotLoading });
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      const resTypes = await (
        await getEntitiesType()
      ).info.map(({ id, name }) => ({ value: id, label: name }));
      setEntityType(resTypes);
      const resEntities = await (
        await getEntitiesByType(typeEntity?.value)
      ).map(({ id, name }) => ({ value: id, label: name }));
      setEntities(resEntities);
    })();
  }, [typeEntity?.value]);
  const handleSelectChange = (option: string | number, name: string) => {
    setValue(name, option);
  };
  const typeIssue = (location.state as { type: number }).type;
  const isCongratsOrSugestion = typeIssue === 4 || typeIssue === 3;
  return (
    <Container>
      <FromGroup>
        <LabelEntity>Tipo de entidad*</LabelEntity>
        <Controller
          as={Select}
          options={entityType}
          placeholder={"Seleccione"}
          name={"entityType"}
          rules={{ required: !isCongratsOrSugestion }}
          control={control}
        />
        {errors.entityType?.type === "required" && (
          <Error>Entidad es requerida</Error>
        )}
      </FromGroup>
      <FromGroup>
        <LabelEntity>Entidad*</LabelEntity>
        <Controller
          as={Select}
          options={entities}
          placeholder={"Seleccione"}
          name={"entity"}
          rules={{ required: !isCongratsOrSugestion }}
          control={control}
        />
        {errors.entity?.type === "required" && (
          <Error>Entidad es requerida</Error>
        )}
      </FromGroup>
    </Container>
  );
};

export default Legal;

{
  /* <Container>
      <Area name="title">
        <LabelEntity>Entidad*</LabelEntity>
      </Area>
      <Area name="eps">
        <Checkbox
          ref={register({ required: true })}
          name="entityType"
          value={"eps"}
        >
          <LabelOption>EPS</LabelOption>
          <InputContainer>
            {entity === "eps" ? (
              <Controller
                as={Select}
                styles={stylesSelect}
                options={eps}
                placeholder={"Seleccione"}
                name={"entity"}
                rules={{ required: true }}
                control={control}
                onChange={(value: IOptions) => {
                  handleSelectChange(value.value, "entity");
                }}
              />
            ) : (
              <TextFieldEmpty
                disabled={true}
                value={""}
                placeholder={"Seleccione"}
              />
            )}
          </InputContainer>
        </Checkbox>
      </Area>
      <Area name={"ips"}>
        <Checkbox
          ref={register({ required: true })}
          name="entityType"
          value={"ips"}
        >
          <LabelOption>IPS</LabelOption>
          <InputContainer>
            {entity === "ips" ? (
              <Controller
                as={Select}
                styles={stylesSelect}
                options={ips}
                placeholder={"Seleccione"}
                name={"entity"}
                rules={{ required: true }}
                control={control}
                onChange={(value: IOptions) => {
                  handleSelectChange(value.value, "entity");
                }}
              />
            ) : (
              <TextFieldEmpty
                disabled={true}
                value={""}
                placeholder={"Seleccione"}
              />
            )}
          </InputContainer>
        </Checkbox>
      </Area>

      <Area name="eapb">
        <Checkbox
          ref={register({ required: true })}
          name="entityType"
          value={"eapb"}
        >
          <LabelOption>EAPB</LabelOption>
          <InputContainer>
            {entity === "eapb" ? (
              <Controller
                as={Select}
                rules={{ required: true }}
                styles={stylesSelect}
                options={eapb}
                placeholder={"Seleccione"}
                name={"entity"}
                control={control}
                onChange={(value: IOptions) => {
                  handleSelectChange(value.value, "entity");
                }}
              />
            ) : (
              <TextFieldEmpty
                disabled={true}
                value={""}
                placeholder={"Seleccione"}
              />
            )}
          </InputContainer>
        </Checkbox>
      </Area>
      <Area name="territorial">
        <Checkbox
          ref={register({ required: true })}
          name="entityType"
          value={"et"}
        >
          <InputContainer>
            <LabelOption>Ente Territorial</LabelOption>
            {entity === "et" ? (
              <TextField
                ref={register({ required: true })}
                name="entity"
                placeholder={"Escriba el Ente"}
              />
            ) : (
              <TextFieldEmpty
                value={""}
                disabled={true}
                placeholder={"Escriba el Ente"}
              />
            )}
          </InputContainer>
        </Checkbox>
      </Area>
      <Area name="si">
        <Checkbox
          ref={register({ required: true })}
          name="entityType"
          value={"ss"}
        >
          <LabelOption>Superintendencia Nacional de Salud</LabelOption>
        </Checkbox>
      </Area>
      <Area name="other">
        <Checkbox ref={register()} name="entityType" value={"os"}>
          <LabelOption>Otras Entidades de Vigilancia y Control </LabelOption>
          <InputContainer>
            {entity === "os" ? (
              <TextField
                ref={register({ required: true })}
                name="entity"
                placeholder={"Escriba la entidad"}
              />
            ) : (
              <TextFieldEmpty
                value={""}
                placeholder={"Escriba la entidad"}
                disabled={true}
              />
            )}
          </InputContainer>
        </Checkbox>
      </Area>
      {errors.entityType?.type === "required" && (
        <Error>Entidad es requerida</Error>
      )}
      {errors.entity?.type === "required" && (
        <Error>Entidad es requerida</Error>
      )}
    </Container> */
}
